import { BaseModel } from 'paliari-js-utils'

const attributes = {
  id: '',
  url: '',
  url_square: '',
  thumb: '',
  nome: '',
  tipo: '',
}

class OsmPlanta extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default OsmPlanta
